/** ACE-aligned brand tokens for public intake (matches landing --ace-accent / primary buttons) */
export const ace = {
  red: "#c41e3a",
  redDark: "#8b1528",
  black: "#111111",
  charcoal: "#1f2937",
  white: "#ffffff",
  grayBg: "#f4f5f7",
  grayBorder: "#e5e7eb",
  muted: "#6b7280",
};
